export default __webpack_public_path__ + "static/media/navbar-icon-orders.3b9b6659.svg";